import { fetchWithAuth } from './apiUtils';
import { API_URL } from '../constants/api';

const TEMPLATES_API_URL = `${API_URL}/templates/distributors`;

/**
 * Obtiene todas las plantillas de mensajes de distribuidores.
 * @returns {Promise<any>}
 */
export const getDistributorTemplates = async () => {
    return fetchWithAuth(TEMPLATES_API_URL);
};

/**
 * Actualiza una plantilla de mensaje de distribuidor.
 * @param {string} templateId El ID de la plantilla a actualizar.
 * @param {object} templateData Los datos a actualizar (message_body, is_active, description).
 * @returns {Promise<any>}
 */
export const updateDistributorTemplate = async (templateId, templateData) => {
    const { message_body, is_active, description } = templateData;
    return fetchWithAuth(`${TEMPLATES_API_URL}/${templateId}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ message_body, is_active, description }),
    });
};

/**
 * Actualiza múltiples plantillas de mensajes de distribuidores a la vez.
 * @param {Array<object>} templates - Un array de objetos de plantilla.
 * @returns {Promise<any>}
 */
export const updateDistributorTemplates = async (templates) => {
    return fetchWithAuth(TEMPLATES_API_URL, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ templates }),
    });
};

/**
 * Obtiene todas las variables disponibles para plantillas de distribuidores.
 * @returns {Promise<any>}
 */
export const getDistributorTemplateVariables = async () => {
    return fetchWithAuth(`${TEMPLATES_API_URL}/variables`);
};

/**
 * Previsualiza una plantilla con datos de ejemplo.
 * @param {string} message_body - El mensaje de la plantilla.
 * @param {object} sample_data - Datos de ejemplo (opcional).
 * @returns {Promise<any>}
 */
export const previewDistributorTemplate = async (message_body, sample_data = {}) => {
    return fetchWithAuth(`${TEMPLATES_API_URL}/preview`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ message_body, sample_data }),
    });
};

/**
 * Previsualiza una plantilla con datos reales de un distribuidor.
 * @param {string} message_body - El mensaje de la plantilla.
 * @param {string} distributor_id - ID del distribuidor.
 * @returns {Promise<any>}
 */
export const previewDistributorTemplateAdvanced = async (message_body, distributor_id) => {
    return fetchWithAuth(`${TEMPLATES_API_URL}/preview-advanced`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ message_body, distributor_id }),
    });
};